import { PaginationItemsSize } from "../pagination";

export const ITEMS_PER_PAGE = 12;

export const DEFAULT_CHART_LIST_ITEM_SIZE =
  localStorage.getItem("chartListItemsSize") || PaginationItemsSize.LARGE;
